import React from "react";
import "../styles/HomePage.css";
import heroCoast from "../assets/hero-coast.jpg";

import { useTranslation, Trans } from "react-i18next";
import { FiZap, FiBarChart2, FiHeart } from "react-icons/fi";

import artinappLogo from "../assets/artinapp_logo.jpeg";

export default function HomePage() {
  const { t } = useTranslation();

  // "- madde 1\n- madde 2" biçimindeki değerler metnini gerçek bir listeye çevirir.
  const valueItems = t("home.article.p_values")
    .split("\n")
    .map((line) => line.replace(/^-\s*/, "").trim())
    .filter(Boolean);

  return (
    <main className="home">
      <section
        className="hero"
        role="banner"
        aria-label={t("home.hero.aria")}
        style={{
          backgroundImage: `
            linear-gradient(180deg, rgba(12,28,58,.82) 0%, rgba(17,62,112,.72) 50%, rgba(42,151,230,.62) 100%),
            url(${heroCoast})
          `,
        }}
      >
        <div className="container hero__grid hero__grid--single">
          <div className="hero__copy hero__copy--animated">
            <span className="hero__signature hero-line hero-line--1" aria-hidden="true">
              Implago
            </span>

            <h1 className="display hero-line hero-line--2">
              <span className="accent">{t("home.hero.titleAccent")}</span>{" "}
              {t("home.hero.titleRest")}
            </h1>

            <p className="lead hero-line hero-line--3">
              <Trans i18nKey="home.hero.lead" components={{ strong: <strong key="strong" /> }} />
            </p>

            <div className="hero__actions hero-line hero-line--4">
              <a
                className="btn btn-primary"
                href="/analyze"
                aria-label={t("home.hero.ctaAnalyzeAria")}
              >
                {t("home.hero.ctaAnalyze")}
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="section section--light">
        <div className="container trio">
          <article className="tile tile--sea">
            <div className="tile__head">
              <div className="tile__icon"><FiZap aria-hidden="true" /></div>
              <h3 className="tile__h">{t("home.trio.easyMatchTitle")}</h3>
              <span className="tile__arrow" aria-hidden="true">→</span>
            </div>
            <p className="tile__p">{t("home.trio.easyMatchDesc")}</p>
          </article>

          <article className="tile tile--sky">
            <div className="tile__head">
              <div className="tile__icon"><FiBarChart2 aria-hidden="true" /></div>
              <h3 className="tile__h">{t("home.trio.newModelsTitle")}</h3>
              <span className="tile__arrow" aria-hidden="true">→</span>
            </div>
            <p className="tile__p">{t("home.trio.newModelsDesc")}</p>
          </article>

          <article className="tile tile--sand">
            <div className="tile__head">
              <div className="tile__icon"><FiHeart aria-hidden="true" /></div>
              <h3 className="tile__h">{t("home.trio.satisfactionTitle")}</h3>
              <span className="tile__arrow" aria-hidden="true">→</span>
            </div>
            <p className="tile__p">{t("home.trio.satisfactionDesc")}</p>
          </article>
        </div>
      </section>

      <section className="section">
        <div className="container article-grid">
          <article className="info-card info-card--span2">
            <h2 className="info-card__title">{t("home.article.h2_brand")}</h2>
            <p className="info-card__text">{t("home.article.p_brand")}</p>
            <svg className="info-card__motif" viewBox="0 0 120 120" aria-hidden="true" focusable="false">
              <path d="M31 17c10-4 18 .5 24 3.3 4.2 2 7.5 3.5 11 3.5s6.8-1.5 11-3.5C83 17.5 91 13 101 17c12.8 5.2 19.5 17 18.2 32.1-1 12.2-6 22.7-11.1 32.6-3.6 6.9-5.5 14.4-7.2 21.5-2.4 10.1-5.1 21.2-13.5 21.2-8.3 0-11.3-10.6-13.7-19-1.9-6.9-3.7-13.4-7.8-13.4s-5.9 6.5-7.8 13.4c-2.4 8.4-5.4 19-13.7 19-8.4 0-11.1-11.1-13.5-21.2-1.7-7.1-3.6-14.6-7.2-21.5C18.7 71.8 13.7 61.3 12.7 49.1 11.5 34 18.2 22.2 31 17Z" fill="none" stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </article>

          <article className="info-card">
            <h2 className="info-card__title">{t("home.article.h2_values")}</h2>
            <ul className="info-card__list">
              {valueItems.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            <svg className="info-card__motif" viewBox="0 0 120 120" aria-hidden="true" focusable="false">
              <path d="M31 17c10-4 18 .5 24 3.3 4.2 2 7.5 3.5 11 3.5s6.8-1.5 11-3.5C83 17.5 91 13 101 17c12.8 5.2 19.5 17 18.2 32.1-1 12.2-6 22.7-11.1 32.6-3.6 6.9-5.5 14.4-7.2 21.5-2.4 10.1-5.1 21.2-13.5 21.2-8.3 0-11.3-10.6-13.7-19-1.9-6.9-3.7-13.4-7.8-13.4s-5.9 6.5-7.8 13.4c-2.4 8.4-5.4 19-13.7 19-8.4 0-11.1-11.1-13.5-21.2-1.7-7.1-3.6-14.6-7.2-21.5C18.7 71.8 13.7 61.3 12.7 49.1 11.5 34 18.2 22.2 31 17Z" fill="none" stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </article>

          <article className="info-card">
            <h2 className="info-card__title">{t("home.article.h2_vision")}</h2>
            <p className="info-card__text">{t("home.article.p_vision")}</p>
            <svg className="info-card__motif" viewBox="0 0 120 120" aria-hidden="true" focusable="false">
              <path d="M31 17c10-4 18 .5 24 3.3 4.2 2 7.5 3.5 11 3.5s6.8-1.5 11-3.5C83 17.5 91 13 101 17c12.8 5.2 19.5 17 18.2 32.1-1 12.2-6 22.7-11.1 32.6-3.6 6.9-5.5 14.4-7.2 21.5-2.4 10.1-5.1 21.2-13.5 21.2-8.3 0-11.3-10.6-13.7-19-1.9-6.9-3.7-13.4-7.8-13.4s-5.9 6.5-7.8 13.4c-2.4 8.4-5.4 19-13.7 19-8.4 0-11.1-11.1-13.5-21.2-1.7-7.1-3.6-14.6-7.2-21.5C18.7 71.8 13.7 61.3 12.7 49.1 11.5 34 18.2 22.2 31 17Z" fill="none" stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </article>

          <article className="info-card">
            <h2 className="info-card__title">{t("home.article.h2_social")}</h2>
            <p className="info-card__text">{t("home.article.p_social")}</p>
            <a className="info-card__link" href="/social">
              {t("home.article.socialCta")} <span aria-hidden="true">→</span>
            </a>
            <svg className="info-card__motif" viewBox="0 0 120 120" aria-hidden="true" focusable="false">
              <path d="M31 17c10-4 18 .5 24 3.3 4.2 2 7.5 3.5 11 3.5s6.8-1.5 11-3.5C83 17.5 91 13 101 17c12.8 5.2 19.5 17 18.2 32.1-1 12.2-6 22.7-11.1 32.6-3.6 6.9-5.5 14.4-7.2 21.5-2.4 10.1-5.1 21.2-13.5 21.2-8.3 0-11.3-10.6-13.7-19-1.9-6.9-3.7-13.4-7.8-13.4s-5.9 6.5-7.8 13.4c-2.4 8.4-5.4 19-13.7 19-8.4 0-11.1-11.1-13.5-21.2-1.7-7.1-3.6-14.6-7.2-21.5C18.7 71.8 13.7 61.3 12.7 49.1 11.5 34 18.2 22.2 31 17Z" fill="none" stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </article>

          <article className="info-card">
            <h2 className="info-card__title">{t("home.article.h2_updates")}</h2>
            <p className="info-card__text">{t("home.article.p_updates")}</p>
            <a className="info-card__link" href="/events">
              {t("home.article.eventsCta")} <span aria-hidden="true">→</span>
            </a>
            <svg className="info-card__motif" viewBox="0 0 120 120" aria-hidden="true" focusable="false">
              <path d="M31 17c10-4 18 .5 24 3.3 4.2 2 7.5 3.5 11 3.5s6.8-1.5 11-3.5C83 17.5 91 13 101 17c12.8 5.2 19.5 17 18.2 32.1-1 12.2-6 22.7-11.1 32.6-3.6 6.9-5.5 14.4-7.2 21.5-2.4 10.1-5.1 21.2-13.5 21.2-8.3 0-11.3-10.6-13.7-19-1.9-6.9-3.7-13.4-7.8-13.4s-5.9 6.5-7.8 13.4c-2.4 8.4-5.4 19-13.7 19-8.4 0-11.1-11.1-13.5-21.2-1.7-7.1-3.6-14.6-7.2-21.5C18.7 71.8 13.7 61.3 12.7 49.1 11.5 34 18.2 22.2 31 17Z" fill="none" stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </article>
        </div>
      </section>

      <footer className="site-footer">
        <div className="container footer__grid">
          <div className="footer__brand">
            <div className="badge">{t("footer.badge")}</div>
            <div>
              <strong>{t("footer.brandTitle")}</strong>
              <div className="sub">{t("footer.brandSub")}</div>
            </div>
          </div>

          <div className="footer__copy">
            <div className="footer__copyRow">
              <img className="footer__centerLogo" src={artinappLogo} alt="ArtInApp" />
              <div className="footer__copyText">
                <div>© {new Date().getFullYear()} {t("footer.copy")}</div>
                <div className="footer__productNote">{t("footer.productNote")}</div>
              </div>
            </div>
          </div>

          <div className="home-footer">
            <span className="home-footer-label">{t("footer.contactLabel")}</span>{" "}
            <a
              className="home-footer-mail"
              href="mailto:info@implago.com?subject=Implago%20İletişim"
            >
              info@implago.com
            </a>
          </div>
        </div>
      </footer>
    </main>
  );
}